import { Action } from 'common/interfaces/root';
import { accessActionTypes as TYPES } from '../actions/access';

const initialState: CommonModule.AccessState = {
  loading: false,
  data: null,
  error: null,
};

export default (
  state: CommonModule.AccessState = initialState,
  { type, payload }: Action
): CommonModule.AccessState => {
  switch (type) {
    case TYPES.GET_ACCESS:
      return { ...state, loading: true };
    case TYPES.GET_ACCESS_SUCCESS:
      return { ...state, loading: false, data: payload };
    case TYPES.GET_ACCESS_ERROR:
      return { ...state, loading: false, error: payload };

    default:
      return state;
  }
};
